import React from 'react';
import { FC } from 'react';

import cn from 'classnames';

import { Badge } from '@shared/components/bootstrap';

import { TransferState as GraphQLTransferState } from '@admin/schema';

type RestTransferState = 'approved' | 'enroute' | 'arrived' | 'completed' | 'canceled';

const TRANSFER_STATE_STYLES: Record<GraphQLTransferState | RestTransferState, string> = {
  approved: 'label-success',
  enroute: 'label-warning',
  arrived: 'label-info',
  completed: 'label-success',
  canceled: 'label-danger',
  [GraphQLTransferState.Approved]: 'label-success',
  [GraphQLTransferState.Enroute]: 'label-warning',
  [GraphQLTransferState.Arrived]: 'label-info',
  [GraphQLTransferState.Completed]: 'label-success',
  [GraphQLTransferState.Canceled]: 'label-danger',
};

const TRANSFER_STATE_NAMES: Record<GraphQLTransferState | RestTransferState, string> = {
  approved: 'Approved',
  enroute: 'Enroute',
  arrived: 'Arrived',
  completed: 'Completed',
  canceled: 'Canceled',
  [GraphQLTransferState.Approved]: 'Approved',
  [GraphQLTransferState.Enroute]: 'Enroute',
  [GraphQLTransferState.Arrived]: 'Arrived',
  [GraphQLTransferState.Completed]: 'Completed',
  [GraphQLTransferState.Canceled]: 'Canceled',
};

export const TransferStateLabel: FC<{
  transfer: { state: GraphQLTransferState | RestTransferState };
}> = ({ transfer }) => (
  <span className={cn('label', TRANSFER_STATE_STYLES[transfer.state])}>{TRANSFER_STATE_NAMES[transfer.state]}</span>
);
